/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, forwardRef } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import MaterialTable from "material-table";
import moment from "moment";
import "moment/locale/es";
import { Container, Button, Tab, Tabs } from "@mui/material";
import { makeStyles } from "@mui/styles";
import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";
import { TicketComments } from "./Comments/TicketComments";
import { getTickets } from "../../Store/Ducks/duckTickets";
import { getSupplierCuit } from "../../Store/Ducks/duckSupplier";
import { ROUTES, TICKET_TYPE } from "../../constants";
import { useLocation } from "react-router-dom";

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => (
    <ChevronRight {...props} ref={ref} />
  )),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

const STATUS_TICKETS = {
  INPROGRESS: "EN CURSO",
  CLOSED: "CERRADAS",
};

const useStyles = makeStyles((theme) => ({
  button: {
    display: "flex",
    alignSelf: "flex-end",
  },
  materialTable: {
    padding: "10px",
    backgroundColor: "white",
    boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.91)",
  },
}));

export const TicketsList = ({ email }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const classes = useStyles();

  const [activeTab, setActiveTab] = useState(1);
  const [openComments, setOpenComments] = useState(false);
  const [openNewComment, setOpenNewComment] = useState(false);
  const [ticketNumber, setTicketNumber] = useState();
  const [ticketTitle, setTicketTitle] = useState();
  const [ticketCategory, setTicketCategory] = useState();
  const [ticketCategoryId, setTicketCategoryId] = useState();
  const [ticketCreated, setTicketCreated] = useState();
  const [ticketDescription, setTicketDescription] = useState();
  const [updateComment, setUpdateComment] = useState(false);
  const [attachedFilesHeader, setAttachedFilesHeader] = useState();
  const [customFieldsValues, setCustomFieldsValues] = useState();
  const [invgateID, setInvgateID] = useState();
  const [showInterferences, setshowInterferences] = useState(
    state?.type === "interferencia"
  );

  const tickets = useSelector((store) => store.tickets.data.tickets);
  useEffect(() => {
    dispatch(getSupplierCuit(email));
  }, [dispatch, email]);

  useEffect(() => {
    dispatch(getTickets(email));
    setUpdateComment(false);
  }, [dispatch, email, updateComment]);

  const handleClickCommentsList = (rowData) => {
    setOpenComments(true);
    setTicketNumber(rowData.ticketNumber);
    setTicketTitle(rowData.title);
    setTicketCategory(rowData.category);
    setTicketCategoryId(rowData.invgateCategoryId);
    setTicketCreated(rowData.created);
    setTicketDescription(rowData.description);
    setAttachedFilesHeader(rowData.attached_files_header);
    setCustomFieldsValues(rowData.customFields);
    setInvgateID(rowData.invgateID);
  };

  const handleClose = () => {
    setOpenNewComment(false);
    setOpenComments(false);
  };

  const columnWidth = (index) => {
    switch (index) {
      case 0:
        return "10%";
      case 1:
        return "20%";
      case 2:
        return "30%";
      case 3:
        return "40%";
      default:
        return "auto";
    }
  };

  const getTableConfig = (status, ticketsToConfig) => {
    const currentTicketsByStep = showInterferences
      ? ticketsToConfig.filter((ticket) =>
          status === 6
            ? ticket.status === status
            : [1, 2, 3, 4, 5, 7].includes(ticket.status) &&
              ticket.type === TICKET_TYPE.INTERFERENCE
        )
      : ticketsToConfig.filter((ticket) =>
          status === 6
            ? ticket.status === status
            : [1, 2, 3, 4, 5, 7].includes(ticket.status) &&
              ticket.type !== TICKET_TYPE.INTERFERENCE
        );
    return {
      status,
      columns: [
        {
          title: <span style={{ fontSize: "18px" }}>#</span>,
          field: "ticketNumber",
          cellStyle: { width: columnWidth(0) },
        },
        {
          title: <span style={{ fontSize: "18px" }}>Título</span>,
          field: "title",
          cellStyle: { width: columnWidth(2) },
        },
        {
          title: <span style={{ fontSize: "18px" }}>Último Comentario</span>,
          field: "descriptionLastComment",
          cellStyle: { width: columnWidth(3) },
          render: (rowData) => {
            const maxLength = 140;
            const truncatedText =
              rowData.descriptionLastComment.length > maxLength
                ? rowData.descriptionLastComment.substr(0, maxLength) + "..."
                : rowData.descriptionLastComment;
            return <span dangerouslySetInnerHTML={{ __html: truncatedText }} />;
          },
        },
        {
          title: <span style={{ fontSize: "18px" }}>Aging</span>,
          field: "dateTimeLastComment",
          cellStyle: { width: columnWidth(1) },
          render: (rowData) => {
            if (!rowData.dateTimeLastComment) return null;
            const lastCommentDate = moment.utc(
              rowData.dateTimeLastComment,
              "M/D/YYYY h:mm:ss A"
            );
            const currentDate = moment();
            const aging = lastCommentDate.from(currentDate);
            const agingCapitalized =
              aging.charAt(0).toUpperCase() + aging.slice(1);
            return <span>{agingCapitalized}</span>;
          },
        },
      ],
      title: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
          }}
        >
          {status !== 6 && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                marginLeft: "0px",
                fontSize:"1.2rem"
              }}
            >
              <span
                onClick={() => setshowInterferences(!showInterferences)}
                style={{
                  background: !showInterferences ? "rgb(0, 153, 0)" : "#CBCBCB",
                  borderRadius: "5px 0 0px 5px",
                  padding: "5px 8px",
                  width:"120px",
                  textAlign:"center",
                  fontFamily:"Roboto,Helvetica,Arial,sans-serif",                  
                  color: !showInterferences ? "#fff" : "#818181",
                  cursor: "pointer",
                  zIndex: 2,
                  boxShadow: !showInterferences
                    ? "0px 0px 5px 0px rgba(0,0,0,0.75)"
                    : "",
                }}
              >
                Consultas
              </span>
              <span
                onClick={() => setshowInterferences(!showInterferences)}
                style={{
                  background: showInterferences ? "rgb(0, 153, 0)" : "#CBCBCB",
                  borderRadius: "0px 5px 5px 0px",
                  cursor: "pointer",
                  width:"120px",
                  fontFamily:"Roboto,Helvetica,Arial,sans-serif", 
                  textAlign:"center",
                  zIndex: showInterferences ? 3 : 1,
                  boxShadow: showInterferences
                    ? "0px 0px 5px 0px rgba(0,0,0,0.75)"
                    : "",
                  padding: "5px 8px",
                  color: showInterferences ? "#fff" : "#818181",
                }}
              >
                Interferencias
              </span>
            </div>
          )}
        </div>
      ),
      data: currentTicketsByStep,
    };
  };
  const [currentTableConfig, setCurrentTableConfig] = useState();

  useEffect(() => {
    setCurrentTableConfig(getTableConfig(1, tickets));
  }, [tickets, state?.isInterference]);

  useEffect(() => {
    setCurrentTableConfig(getTableConfig(1, tickets));
  }, [showInterferences]);

  const handleTabChange = (event, newValue) => {
    const status = newValue === 1 ? 1 : 6;
    setCurrentTableConfig(getTableConfig(status, tickets));
    setActiveTab(newValue);
  };

  return (
    <>
      <Container>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <Button
            onClick={() =>
              history.push(ROUTES.TICKET_CREATION, { origin: "fromTicket" })
            }
            variant="contained"
            className={classes.button}
          >
            {" "}
            Nueva Consulta{" "}
          </Button>
        </div>

        <Tabs value={activeTab} onChange={handleTabChange}>
          <Tab label={STATUS_TICKETS.INPROGRESS} value={1} />
          <Tab label={STATUS_TICKETS.CLOSED} value={2} />
        </Tabs>
        <div style={{ position: "relative" }}>
          <MaterialTable
            className={classes.materialTable}
            columns={currentTableConfig?.columns}
            data={currentTableConfig?.data}
            icons={tableIcons}
            title={currentTableConfig?.title}
            columnWidth={columnWidth}
            onRowClick={(event, rowData) => handleClickCommentsList(rowData)}
            options={{
              rowStyle: (rowData) => ({
                backgroundColor:
                  TICKET_TYPE.INTERFERENCE === rowData.type &&
                  rowData.status !== 6
                    ? "#fff5f5"
                    : "",
              }),
              actionsColumnIndex: -1,
            }}
            localization={{
              header: {
                actions: "Comentarios",
              },
              body: {
                emptyDataSourceMessage:
                  activeTab === 1 &&
                  "Parece que aún no has creado consultas o todas ellas se encuentran cerradas. Si quieres realizar una consulta haz clic en el botón NUEVA CONSULTA.",
              },
            }}
          />
          <p
            style={{
              color: "#009900",
              fontSize: "15px",
              position: "absolute",
              fontFamily:"Roboto,Helvetica,Arial,sans-serif",
              bottom: "0px",
              marginLeft: "15px",
            }}
          >
            Para ver los comentarios de una consulta, haga clic en una fila.
          </p>
        </div>

        <TicketComments
          openComments={openComments}
          openNewComment={openNewComment}
          ticketNumber={ticketNumber}
          ticketTitle={ticketTitle}
          ticketCategory={ticketCategory}
          ticketCategoryId={ticketCategoryId}
          ticketCreated={ticketCreated}
          ticketDescription={ticketDescription}
          attachedFilesHeader={attachedFilesHeader}
          customFieldsValues={customFieldsValues}
          invgateID={invgateID}
          handleClose={handleClose}
          setOpenNewComment={setOpenNewComment}
          setUpdateComment={setUpdateComment}
          email={email}
          tickets={tickets}
        />
      </Container>
    </>
  );
};
